import requestModule from '@/application/libs/requestModule'
import Util from  '@/application/libs/util'

export default {
    getGrouplessPlates(){
        const {
            TPCONTRATO: IDTIPORESTRICAO,
            CDFILIAL,
            CDSERVFILI,
            IDUTRPADCA
        } = Util.getFilterInSession();
        return requestModule.postRequest('getData', {
            FROM: "PRATOSEMGRUPO",
            PARAMS: {
                IDTIPORESTRICAO,
                CDFILIAL,
                CDSERVFILI,
                IDUTRPADCA
            }
        }).then(response=>response.dataset && response.dataset.data);
    },
    getGroupsForGrouplessPlates(){
        const {
            TPCONTRATO: IDTIPORESTRICAO,
            CDFILIAL,
            CDSERVFILI
        } = Util.getFilterInSession();
        return requestModule.postRequest('getData', {
            FROM: "GRUPOPRAT",
            PARAMS: { IDTIPORESTRICAO, CDFILIAL, CDSERVFILI }
        }).then(response=>response.dataset && response.dataset.data);
    },
    getPlateGroupStandard(){
        const { TPCONTRATO: IDTIPORESTRICAO } = Util.getFilterInSession();
        return requestModule.postRequest('getData', {
            FROM: "PADGRUPOPRATO",
            PARAMS: { IDTIPORESTRICAO }
        }).then(response=>response.dataset && response.dataset.data);
    },

    /**
     * Returns plate groups defaults to add.
     * 
     * @param {Object} params
     * 
     * @returns {Promise}
     */
    getGroupsToAdd(params){
        return requestModule.postRequest('getData', {
            FROM: "GROUPS_TO_ADD",
            PARAMS: params
        }).then(response=>response.dataset && response.dataset.data);
    },

    /**
     * Returns plates registered in unit and service
     * to add.
     * 
     * @param {Object} params
     * 
     * @returns {Promise}
     */
    getNewPlatesToAdd: function(params){
        const { TPCONTRATO: IDTIPORESTRICAO } = Util.getFilterInSession();
        return requestModule.postRequest('getData', {
            FROM: "PLATES_TO_ADD",
            PARAMS: {
                ...params,
                IDTIPORESTRICAO
            }
        }).then(response=>response.dataset && response.dataset.data);
    },

    /**
     * Save new plate register.
     * 
     * @param {Object} params 
     */
    saveNewPlate(params){
        return requestModule.postRequest('insertData', {
            FROM: "NEW_PLATE",
            PARAMS: params
        }).then(response=>response.dataset && response.dataset.data);
    },

    /**
     * Returns plate groupset defaults to add.
     * 
     * @param {Object} params
     * 
     * @returns {Promise}
     */
    getGroupsetToAdd(params){
        return requestModule.postRequest('getData', {
            FROM: "GROUPSET_TO_ADD",
            PARAMS: params
        }).then(response=>response.dataset && response.dataset.data);
    },

    /**
     * Returns plate groups according to filtered data.
     * 
     * @param {Object} params
     * 
     * @returns {Promise}
     */
    getPlatesGroups(params){
        return requestModule.postRequest('getData', {
            FROM: "PLATEGROUPS",
            PARAMS: params
        }).then(response=>response.dataset && response.dataset.data);
    },

    getExportPlatesGroups(params){
        return requestModule.postRequest('getData', {
            FROM: "EXPORTPLATEGROUPS",
            PARAMS: params
        }).then(response=>response.dataset && response.dataset.data);
    },

    getPlateGroupGrouping(){
        const { TPCONTRATO: IDTIPORESTRICAO } = Util.getFilterInSession();
        return requestModule.postRequest('getData', {
            FROM: "AGRUPGRPRAT",
            PARAMS: { IDTIPORESTRICAO }
        }).then(response=>response.dataset && response.dataset.data);
    },

    getPlateRecipe(plateFilter){
        return requestModule.postRequest('getData', {
            FROM: "PLATE_RECIPE",
            PARAMS: plateFilter
        }).then((response) => {
            let data = response.dataset && response.dataset.data
            
            return data.map(item => ({
                ...item,
                CDFILAUXPRAT: plateFilter.CDFILAUXPRAT,
                CDPRATO: plateFilter.CDPRATO
            }));
        });
    },

    saveChangedData(changedData, dataSourceName){
        return requestModule.postRequest('updateData', {
            FROM: dataSourceName,
            PARAMS: changedData,
        }).then(response => {
            if(!response.error){
                return(response);
            } else {
                throw response;
            }
        }).catch(e => {
            if(e.errorCode !== 0){
                throw e;
            } else {
                throw {};
            }
        });
    },

    savePlateGroups(params){
        return requestModule.postRequest('insertData',{
            FROM:'PLATE_GROUP',
            PARAMS:params
        });
    },
    
    updatePlateGroups(params){
        return requestModule.postRequest('updateData',{
            FROM:'PLATE_GROUP',
            PARAMS:params
        });
    },

    delPlateGroup(params){
        return requestModule.postRequest('deleteData',{
            FROM:'PLATE_GROUP',
            PARAMS:params
        });
    },
    delPlateRegister(params){
        return requestModule.postRequest('deleteData',{
            FROM:'GROUP_PLATE_PLT',
            PARAMS:params
        });
    },

    insertData(data, dataSourceName){
        return requestModule.postRequest('insertData', {
            FROM: dataSourceName,
            PARAMS: data,
        }).then(response => {
            if(!response.error){
                return(response);
            } else {
                throw response;
            }
        }).catch(e => {
            if(e.errorCode !== 0){
                throw e;
            } else {
                throw {};
            }
        });
    },
    deleteData(data, dataSourceName){
        return requestModule.postRequest('deleteData', {
            FROM: dataSourceName,
            PARAMS: data,
        }).then(response => {
            if(!response.error){
                return(response);
            } else {
                throw response;
            }
        }).catch(e => {
            if(e.errorCode !== 0){
                throw e;
            } else {
                throw {};
            }
        });
    },
    /**
     * Returns plate according to selected plate group.
     * 
     * @param {Object} params
     * 
     * @returns {Promise}
     */
    getPlatesByGroup(params){
        return requestModule.postRequest('getData', {
            FROM: "PLATES_BY_GROUP",
            PARAMS: params
        }).then(response=>response.dataset && response.dataset.data);
    },
    
    updatePlateRecipe(params){
        return requestModule.postRequest('updateData',{
            FROM:'QTDERECEITA',
            PARAMS:params
        });
    },
};